import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22font-provider.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../public/fonts/SFPro-Display-Bold.woff2%22,%22display%22:%22swap%22,%22variable%22:%22--sfpro-display-bold%22}],%22variableName%22:%22SFProDisplayBold%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'SFProDisplayBold', 'SFProDisplayBold Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
